/**
 * Unified Countdown Timers
 * Handles both cart promo (simple) and PDP (full boxes) countdown formats.
 * Hardened: robust date parsing (iOS/Safari safe), multi-event init, re-scan on
 * cart/section updates, and resilient to elements added after initial load.
 */
(function() {
  'use strict';

  var initialized = new WeakSet();

  /* Parse a date string robustly across browsers.
     Safari/iOS can choke on some ISO variants, so we normalize and fall back. */
  function parseDate(raw) {
    if (!raw) return null;
    var s = String(raw).trim();
    if (!s) return null;

    var d = new Date(s);
    if (!isNaN(d.getTime())) return d;

    /* Fallback: replace space with T (e.g. "2026-05-26 23:59:00-08:00") */
    var d2 = new Date(s.replace(' ', 'T'));
    if (!isNaN(d2.getTime())) return d2;

    /* Fallback: strip timezone and parse as local */
    var d3 = new Date(s.replace(/[+-]\d{2}:?\d{2}$/, '').replace(' ', 'T'));
    if (!isNaN(d3.getTime())) return d3;

    return null;
  }

  /* Cart Promo Timer - Simple "Ends Xh Xm" format */
  function initCartTimer(el) {
    if (!el || initialized.has(el)) return;

    var expiry = parseDate(el.dataset.expiry);
    if (!expiry) {
      el.textContent = 'Expired';
      return;
    }
    initialized.add(el);

    var handle;
    function tick() {
      var dist = expiry.getTime() - Date.now();
      if (dist <= 0) {
        el.textContent = 'Expired';
        if (handle) clearInterval(handle);
        return;
      }
      var h = Math.floor(dist / 3600000);
      var m = Math.floor((dist % 3600000) / 60000);
      el.textContent = 'Ends ' + h + 'h ' + m + 'm';
    }

    tick();
    handle = setInterval(tick, 60000);
  }

  /* PDP Timer - Full DD:HH:MM:SS boxes format */
  function initPdpTimer(container) {
    if (!container || initialized.has(container)) return;

    var boxesEl = container.querySelector('.countdown-timer__boxes');
    var expiry = parseDate(container.dataset.countdown);
    if (!boxesEl) return;
    if (!expiry) {
      boxesEl.innerHTML = '<div class="countdown-timer__box"><span class="countdown-timer__value">EXPIRED</span></div>';
      return;
    }
    initialized.add(container);

    var daysEl = boxesEl.querySelector('.countdown-days');
    var hoursEl = boxesEl.querySelector('.countdown-hours');
    var minutesEl = boxesEl.querySelector('.countdown-minutes');
    var secondsEl = boxesEl.querySelector('.countdown-seconds');

    var handle;
    function tick() {
      var dist = expiry.getTime() - Date.now();
      if (dist <= 0) {
        if (handle) clearInterval(handle);
        boxesEl.innerHTML = '<div class="countdown-timer__box"><span class="countdown-timer__value">EXPIRED</span></div>';
        return;
      }

      var d = Math.floor(dist / 86400000);
      var h = Math.floor((dist % 86400000) / 3600000);
      var m = Math.floor((dist % 3600000) / 60000);
      var s = Math.floor((dist % 60000) / 1000);

      if (dist < 86400000) {
        boxesEl.classList.add('is-subday');
      } else {
        boxesEl.classList.remove('is-subday');
      }

      if (daysEl) daysEl.textContent = String(d).padStart(2, '0');
      if (hoursEl) hoursEl.textContent = String(h).padStart(2, '0');
      if (minutesEl) minutesEl.textContent = String(m).padStart(2, '0');
      if (secondsEl) secondsEl.textContent = String(s).padStart(2, '0');
    }

    tick();
    handle = setInterval(tick, 1000);
  }

  /* Initialize all timers currently on the page */
  function initAll() {
    document.querySelectorAll('[data-timer-id="cart-promo-timer"]').forEach(initCartTimer);
    document.querySelectorAll('.countdown-timer[data-countdown]').forEach(initPdpTimer);
  }

  /* Run on DOM ready (and immediately if already past loading) */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  /* Also run once more after full load, in case markup streamed in late */
  window.addEventListener('load', initAll);

  /* Re-scan when the cart drawer / sections re-render (Shopify AJAX events) */
  document.addEventListener('cart:refresh', initAll);
  document.addEventListener('cart:updated', initAll);
  document.addEventListener('cart:open', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('shopify:section:select', initAll);

  /* Watch for dynamically added timers (cart drawer AJAX, etc.) */
  var observer = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var node = nodes[j];
        if (node.nodeType !== 1) continue;

        if (node.matches && node.matches('[data-timer-id="cart-promo-timer"]')) {
          initCartTimer(node);
        } else if (node.matches && node.matches('.countdown-timer[data-countdown]')) {
          initPdpTimer(node);
        }

        if (node.querySelectorAll) {
          node.querySelectorAll('[data-timer-id="cart-promo-timer"]').forEach(initCartTimer);
          node.querySelectorAll('.countdown-timer[data-countdown]').forEach(initPdpTimer);
        }
      }
    }
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    });
  }
})();